import Component from 'flarum/common/Component';
import textContrastClass from 'flarum/common/helpers/textContrastClass';
import tagIcon from '../../common/helpers/tagIcon';
import classList from 'flarum/common/utils/classList';

export default class TagHero extends Component {
  view() {
    const tag = this.attrs.model;
    const color = tag.color();
    let name = tag.name();
    // 将字符串映射转换为 JavaScript 对象
    const obj = JSON.parse(name);
    // 创建 Map 对象并初始化
    const map = new Map(Object.entries(obj));
    // 获取特定键的值
    let localeName = map.get(app.data.locale);
    return (
      <header
        className={classList('Hero', 'TagHero', { 'TagHero--colored': color, [textContrastClass(color)]: color })}
        style={color ? { '--hero-bg': color } : undefined}
      >
        <div className="container">
          <div className="containerNarrow">
            <h1 className="Hero-title">
              {tag.icon() && tagIcon(tag, {}, { useColor: false })} {localeName}
            </h1>
            <div className="Hero-subtitle">{tag.description()}</div>
          </div>
        </div>
      </header>
    );
  }
}
